export default __webpack_public_path__ + "static/media/Mark-4-HUD-03.18e6b1d2.jpg";